import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  todos: [],
};

export const todoSlice = createSlice({
  name: "todo",
  initialState,
  reducers: {
    addToList: (state, action) => {
      state.todos = action.payload;
    },
  },
});

export const { addToList } = todoSlice.actions;

// export const todoListSelector = (state) => state.todo.todos;

export default todoSlice.reducer;
